<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <b-navbar-nav class="d-flex align-items-center">
      <b-nav-item-dropdown
        v-if="companyList.length > 1 && !isUsersOrCompaniesPage"
        left
        toggle-class="d-flex align-items-center dropdown-company-link"
        class="dropdown-companies"
      >
        <template #button-content>
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="flat-primary"
          >
            <span class="align-middle">Companies</span>
            <feather-icon
              icon="ChevronDownIcon"
              class="ml-50"
            />
          </b-button>
        </template>
        <div
          v-for="(company, index) in companyList"
          :key="(index + 1)"
        >
          <b-dropdown-item
            :link-class="{
              'active': selectedCompanies.includes(company.id),
              'd-flex align-items-center justify-content-between': true
            }"
            @click="toggleCompanySelection(company.id)"
          >
            <span>{{ company.name }}</span>
            <feather-icon
              v-if="selectedCompanies.includes(company.id)"
              size="16"
              icon="XIcon"
            />
          </b-dropdown-item>
        </div>
      </b-nav-item-dropdown>
      <b-nav-item
        v-if="companyList.length > 1 && !isUsersOrCompaniesPage"
        class="companies-avatars"
      >
        <selected-companies :companies="filteredCompanies" />
      </b-nav-item>
    </b-navbar-nav>
    <b-navbar-nav class="nav align-items-center ml-auto">
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p
              class="user-name font-weight-bolder mb-0"
              v-text="userName"
            />
            <span
              v-if="companyList.length === 1"
              class="user-status"
              v-text="companyName"
            />
          </div>
          <b-avatar
            size="40"
            variant="light-primary"
            :text="avatarText(userName)"
          />
        </template>

        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="$router.push({ name: 'account-edit' })"
        >
          <feather-icon
            size="16"
            icon="UserIcon"
            class="mr-50"
          />
          <span>Profile</span>
        </b-dropdown-item>

        <b-dropdown-divider />

        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="clickLogout"
        >
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
          />
          <span>Logout</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav, BNavItem, BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar, BButton,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import SelectedCompanies from './SelectedCompanies.vue'
import { avatarText, getSelectedCompanies, updateSelectedCompanies } from '@core/utils/filter'
import { EventBus } from '@core/utils/utils'
import Vue from 'vue'
import { logout } from '@/auth/sanctum'
import router from '@/router'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BLink,
    BNavItem,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    BButton,
    SelectedCompanies,
  },
  setup() {
    return {
      avatarText,
    }
  },
  directives: {
    Ripple,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      selectedCompanies: getSelectedCompanies(),
    }
  },
  computed: {
    userName() {
      if (Vue.prototype.$profile().data.user) {
        return Vue.prototype.$profile().data.user.name
      }
      return ''
    },
    companyList() {
      if (Vue.prototype.$profile().data.user) {
        return Vue.prototype.$profile().data.user.companies
      }
      return []
    },
    companyName() {
      if (Vue.prototype.$activeCompany().data.company) {
        return Vue.prototype.$activeCompany().data.company.name
      }
      return ''
    },
    filteredCompanies() {
      return this.companyList.filter(company => this.selectedCompanies.includes(company.id))
    },
    isUsersOrCompaniesPage() {
      return this.$route.path.startsWith('/users')
          || this.$route.path.startsWith('/companies')
    },
  },
  mounted() {
    EventBus.$on('removeCompany', this.toggleCompanySelection)
    EventBus.$on('selectCompany', this.selectSingleCompany)
  },
  beforeDestroy() {
    EventBus.$off('removeCompany', this.toggleCompanySelection)
    EventBus.$off('selectCompany', this.selectSingleCompany)
  },
  methods: {
    clickLogout() {
      logout()
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Logout successful',
          icon: 'EditIcon',
          variant: 'success',
        },
      })
      router.push({ name: 'login' })
    },
    toggleCompanySelection(id) {
      const index = this.selectedCompanies.indexOf(id)
      if (index > -1) {
        this.selectedCompanies.splice(index, 1)
      } else {
        this.selectedCompanies.push(id)
      }
      // TODO: classifiers!
      updateSelectedCompanies(this.selectedCompanies)
      EventBus.$emit('companyListUpdated')
    },
    selectSingleCompany(id) {
      this.selectedCompanies = [id]
      updateSelectedCompanies(this.selectedCompanies)
      EventBus.$emit('companyListUpdated')
    },
  },
}
</script>
<style lang="scss">
.dropdown-menu {
  overflow-y: auto;
  max-height: calc(100vh - 100px);
}
[dir] .header-navbar.navbar-shadow {
  box-shadow: none;
  background: none;
}
[dir] .navbar-floating .navbar-container {
  padding-left: 0;
  padding-right: 0;
}
</style>
